import {SurveyPreset} from '../types';

import {useSurveySlug} from 'client/common/contexts/slug';
import {useSurveySettings} from 'client/common/hooks/survey';
import {useSurveyPreset} from 'client/common/hooks/box';

export function useSupportsDarkMode() {
    const settings = useSurveySettings();
    const slug = useSurveySlug();
    const surveyPreset = useSurveyPreset(slug);

    if (surveyPreset && [
        SurveyPreset.YandexActiveFeedback,
        SurveyPreset.YandexPassiveFeedback,
        SurveyPreset.YandexMorda
    ].includes(surveyPreset)) {
        return true;
    }

    return settings?.supportDarkMode;
}
